<template>
    <div>
        <el-button size="small" @click="navigateEdit()">{{ $t('button.Edit') }}</el-button>
    </div>
</template>

<script>
export default {
    props: {
        paramName: {
            type: String,
            default: "id"
        },
        paramId: {
            type: String | Number,
        },
        pageName: {
            type: String,
        },
    },
    computed: {
        navigateInfo() {
            var tempObj = {};
            tempObj[this.paramName] = this.paramId;

            return {
                name: this.pageName,
                params: tempObj
            };
        }
    },
    methods: {
        navigateEdit() {
            this.$_navigateTo(this.navigateInfo);
        }
    },
};
</script>

<style lang="css" scoped>

</style>


// WEBPACK FOOTER //
// src/components/Button/EditButton.vue